import React from 'react';
import GlobalContext from '../../GlobalContext';
import QuoteRequestForm, { BrochureBtn, ImgRender } from '../../BFComponents';

const CanonDRM140 = () => {
    const paths = GlobalContext().paths;
    const pictures = paths.pictures;

    return (
        <div className="container">
            <div className="row justify-content-end">
                <div className="col-md-4 align-self-end">
                    <div className="d-flex justify-content-end">
                        <img id="canon-red-img" src={pictures + "canon-logo-red.svg"}></img></div>
                    <img src={pictures + "imageformula140.svg"}></img>
                </div>
            </div>
            <span className="display-4">Office Document Scanner</span>
            <div id="drc-banner-div">
                <ImgRender width={100} image={"drm140main.jpg"} />
            </div>
            <div className="drc-after-btn">
                <strong className="drc225blue">imageFORMULA DR-M140<br />
Office Document Scanner<br /></strong>
A compact and versatile solution, the imageFORMULA DR-M140 document scanner
helps reduce paperwork and improve workflows. With an out-of-the-box design,
reliable handling, and advanced image quality functions, the DR-M140 is a performancedriven device that provides the basis for an intelligent document capture system.
</div>
            <div className="row">
                <div className="col-md-6"><strong className="drc225blue">Wide Variety of Applications.<br /></strong>
                Each day, legal, medical, government, and financial staff members
are challenged with overwhelming amounts of paperwork. From
invoices to letters and contracts to EKG strips, those in paperbased businesses require a document capture system that helps
ensure efficient information management—that system starts
with the DR-M140 scanner.
                <strong className="drc225blue"><br />Reliable & Versatile<br /></strong>
                Scanning often involves mixed batches of documents. To address
widespread needs, the DR-M140 scanner employs two feeding
paths. The default U-turn path works well for typical jobs, while
the straight path can be selected to handle items such as thick
or thin documents and embossed plastic cards. This scanner also
offers pickup feeding for increased reliability upon initiating a
scan, as well as Ultrasonic Double-Feed Detection to help ensure
that no data is lost if a double-feed occurs.
<strong className="drc225blue"><br />Convenient & Efficient<br /></strong>
The DR-M140 scanner is well suited for desktop use, reducing
the space and the learning curve somtimes required to process
documents. Its front-loading and front-eject features allow users
to easily scan documents without a lengthy tray. A convenient
control panel enables easy access to pre-programmed scanning
tasks, and a Double-Feed Release button on the scanner body
allows users to handle special documents, such as envelopes.
</div>
                <div className="col-md-6">
                    <QuoteRequestForm source={window.location} />
                    <BrochureBtn brochure={"SCANNER--CANON DR-M140 Document Scanner Brochure.pdf"} />

                    <strong className="drc225blue">Productive & Capable<br /></strong>
                The DR-M140 is equipped to scan 6,000 documents per day
by holding 50 sheets in its feeder and scanning up to 40 pages/
80 images per minute in all modes, including color. With such
strong capacities, this scanner helps to effectively transition to
a paperless office.
<strong className="drc225blue">                        <br />High Image Quality<br /></strong>
The DR-M140 scanner maximizes image quality with features
such as Character Emphasis to improve the legibility of hardto-capture documents. The Auto Resolution setting is useful
for scanning mixed batches while automatically adjusting the
resolution to improve clarity and compress file sizes. And
with capabilities such as Background Smoothing and Shadow
Cropping, the DR-M140 scanner emphasizes accurate scanning
and furthers superb output.
                    </div>
            </div>
        </div>
    )
}

export default CanonDRM140;